import { render, staticRenderFns } from "./PelleTab.vue?vue&type=template&id=5bdb9da8&scoped=true"
import script from "./PelleTab.vue?vue&type=script&lang=js"
export * from "./PelleTab.vue?vue&type=script&lang=js"
import style0 from "./PelleTab.vue?vue&type=style&index=0&id=5bdb9da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb9da8",
  null
  
)

export default component.exports